import React,{useState} from "react";
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import MenuBtn from './MenuBtn';

const ProductViewHeader={
  borderBottom: "1px solid #c7c7c7",
  minHeight:"42px"
}



const MenuInterierView =(props)=>{
  

    return(
        <div className="Accordians">
       
         <Accordion style={{borderRadius:"0px"}} onChange={props.onChanged} expanded={props.expanded}>
        <AccordionSummary id="positionBtn" tabIndex="1"
          expandIcon={<ExpandMoreIcon />} style={ProductViewHeader}  onKeyPress={ props.onInterirorBtnClick} onClick={props.onInterirorBtnClick}>
    
        <Typography id="interiorText" className="accordion-headers AccordiansHeader" style={{fontWeight:"700"}}>{props.name}</Typography>
        </AccordionSummary>
        <AccordionDetails tabIndex="1" aria-label="Processor"  id="processorBtn" onKeyPress={ props.onProcessorBtnClick} onClick={props.onProcessorBtnClick}>
        <MenuBtn aria-hidden="true" submenu={window.finalLangues.processor} source="./img/intel.svg"/>

        </AccordionDetails>  
        <AccordionDetails tabIndex="1" aria-label="Memory"  id="memoryBtn" onKeyPress={ props.onMemoryBtnClick} onClick={props.onMemoryBtnClick}>
        <MenuBtn aria-hidden="true" submenu={window.finalLangues.memory} source="./img/memory.png"/>

        </AccordionDetails> 
       
        <AccordionDetails tabIndex="1" aria-label="Dynamic Media Enclosure"  id="DMEnclosure" onKeyPress={ props.onDMEnclosureClick} onClick={props.onDMEnclosureClick}>
        <MenuBtn aria-hidden="true" submenu={window.finalLangues.fans} source="./img/fans.png"/>

        </AccordionDetails>
        
      </Accordion>
     
        </div>
    );
}

export default MenuInterierView;